import React, { Component } from 'react';
import { connect } from 'react-redux';
import moize from 'moize';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import SummaryTile from '@bit/knotchinc.web-react-components.tiles.summary-tile';
import { Grid, Row, Col } from '@bit/knotchinc.web-react-components.grid';
import { PublisherListTile } from 'components/Tiles';
import { SectionTitle } from 'components/Global/Title/Title.jsx';
import Mixpanel from 'helpers/Mixpanel.js';
import { numberWithCommas, formatterWithWord } from 'helpers/Utils.js';
import { ADD_ENTITY_INSIGHTS } from '../actions';
import InsightsBrandLogos from './InsightsBrandLogos.jsx';

class PublishersInsightsTab extends Component {
  constructor() {
    super();
    this.memoFetchMap = moize((entities, fetch) => this.generateFetchMap(entities, fetch));
  }

  componentDidMount() {
    const { entities, entityId, initializeEntity } = this.props;
    if (!entities.length && entityId) {
      initializeEntity(entityId);
    }
    Mixpanel.track(`view Insights: publishers tab`);
  }

  generateFetchMap(entities, fetch) {
    return entities.reduce((acc, key) => {
      acc[key] = (clear) => fetch(clear, key);
      return acc;
    }, {});
  }

  render() {
    const { publishers, entities, metadata, fetchData } = this.props;
    const entitiesList = entities.map(entity => ({ entityId: entity, publisherList: publishers[entity] }));
    const fetchMap = this.memoFetchMap(entities, fetchData);
    const multiEntity = entitiesList.length > 1;

    return (
      <React.Fragment>
        <Grid height={234}>
          <StoreSync stores={publishers}>
            <InsightsBrandLogos metadata={metadata} />
            <Row weight={2}>
              {entitiesList.map(({ entityId, publisherList }) => (
                <Col centered key={`col-total-publishers-${entityId}`}>
                  <SectionTitle>Total Publishers</SectionTitle>
                  <SummaryTile
                    data={publisherList.pagination && publisherList.pagination.total}
                    formatter={formatterWithWord('Publishers', numberWithCommas)}
                    isVerticallyAligned
                  />
                </Col>
            ))}
            </Row>
          </StoreSync>
        </Grid>
        <Grid height="auto">
          <Row weight={8}>
            {entitiesList.map(({ entityId, publisherList }) => (
              <Col centered key={`col-publisher-breakdown-${entityId}`}>
                <SectionTitle>Publisher Breakdown</SectionTitle>
                <PublisherListTile fetchData={fetchMap[entityId]} store={publisherList} multiEntity={multiEntity} />
              </Col>
            ))}
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ Insights: { publishers, metadata } }) => ({
  publishers,
  metadata,
  entities: Object.keys(publishers),
});

const mapDispatchToProps = (dispatch, { entityType }) => ({
  initializeEntity: entityId => dispatch({ type: ADD_ENTITY_INSIGHTS, entityId, entityType }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishersInsightsTab);
